import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { getAllCompaniesForChart } from "../../services/authapi";
import { getAllCompaniesForSupplierChart , getAllCompaniesForOutletChart } from "../../services/contractorApi";
import GraphicalAnalysis from "../Suppliers/360/graph";
import LoaderUi from "../../components/LoaderUi";
import SupplierPieChart from "../Suppliers/360/piechart";
import SupplierBarChart from "../Suppliers/360/barchart";

const AllOutletOverview = ({ checkPermission }) => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchChartsData = async () => {
    const res = await getAllCompaniesForOutletChart();
    if (res.data) {
      setRows(res.data);
    } else {
      setRows([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchChartsData();
  }, []);

  if (isLoading) {
    return <LoaderUi />;
  }

  return (
    <div className="mt-3">
      <Row className="g-3">
        <Col md={4}>
          <div className="shadow h-100 p-2">
            <GraphicalAnalysis rows={rows}  valueType="Outlets" checkPermission={checkPermission} />
          </div>
        </Col>
        <Col md={4}>
          <div className="shadow h-100 p-2">
            <SupplierPieChart rows={rows} valueType="Outlets" checkPermission={checkPermission} />
          </div>
        </Col>
        <Col md={4}>
          <div className="shadow h-100 p-2">
   <SupplierBarChart rows={rows} valueType="Outlets" checkPermission={checkPermission} />
          </div>
        </Col>
       
      </Row>
    </div>
  );
};

export default AllOutletOverview;
